module.exports = __webpack_public_path__ + "static/media/ball_o.60f13d0c.png";